export const FormInputType = Object.freeze({
  DATE: 'date',
  TEXT: 'text',
  TEXTAREA: 'textarea',
  SELECT: 'select',
  RADIO: 'radio',
})
